function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import _classPrivateFieldGet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldSet";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _WeakMap from "@babel/runtime-corejs3/core-js/weak-map";
function _classPrivateFieldInitSpec(obj, privateMap, value) {
  _checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function _checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
import MembershipClient from "../client/index.js";
import MembershipBrowserPersistence from "../browserPersistence/index.js";
import MembershipAnalytics from "../analytics/index.js";
import { createFakeSuccessfulLogoutResponse, createFakeUnauthorizedResponse } from "./fakeResponses/index.js";
var _client = /*#__PURE__*/new _WeakMap();
var _persistence = /*#__PURE__*/new _WeakMap();
var _analytics = /*#__PURE__*/new _WeakMap();
var _storeSession = /*#__PURE__*/new _WeakMap();
var MembershipService = /*#__PURE__*/function () {
  function MembershipService() {
    var _this = this;
    _classCallCheck(this, MembershipService);
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      persistenceOptions = _ref2.persistenceOptions,
      clientOptions = _ref2.clientOptions,
      analyticsOptions = _ref2.analyticsOptions,
      _ref2$client = _ref2.client,
      client = _ref2$client === void 0 ? new MembershipClient(clientOptions) : _ref2$client,
      _ref2$persistence = _ref2.persistence,
      persistence = _ref2$persistence === void 0 ? new MembershipBrowserPersistence(persistenceOptions) : _ref2$persistence,
      _ref2$analytics = _ref2.analytics,
      analytics = _ref2$analytics === void 0 ? new MembershipAnalytics(analyticsOptions) : _ref2$analytics;
    _classPrivateFieldInitSpec(this, _client, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _persistence, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _analytics, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _storeSession, {
      writable: true,
      value: function value(result) {
        _classPrivateFieldGet(_this, _persistence).onLogIn(result.data.session);
        return result;
      }
    });
    _classPrivateFieldSet(this, _client, client);
    _classPrivateFieldSet(this, _persistence, persistence);
    _classPrivateFieldSet(this, _analytics, analytics);
  }
  _createClass(MembershipService, [{
    key: "signUp",
    value: function signUp(params) {
      var _this2 = this;
      var finalParams = _objectSpread({
        brand_version: _classPrivateFieldGet(this, _persistence).getBrandVersion()
      }, params);
      return _classPrivateFieldGet(this, _client).createMember(finalParams).then(_classPrivateFieldGet(this, _storeSession)).then(function (result) {
        return _classPrivateFieldGet(_this2, _analytics).reportSignUp(result.data).then(function () {
          return result;
        });
      });
    }
  }, {
    key: "logIn",
    value: function logIn(params) {
      var _this3 = this;
      return _classPrivateFieldGet(this, _client).createSession(params).then(_classPrivateFieldGet(this, _storeSession)).then(function (result) {
        return _classPrivateFieldGet(_this3, _analytics).reportLogIn(result.data).then(function () {
          return result;
        });
      });
    }
  }, {
    key: "getSessionToken",
    value: function getSessionToken() {
      return _classPrivateFieldGet(this, _persistence).getSessionToken();
    }
  }, {
    key: "getMember",
    value: function getMember() {
      var token = this.getSessionToken();
      if (token) {
        return _classPrivateFieldGet(this, _client).getMember({
          token: token
        });
      }
      return _Promise.reject(createFakeUnauthorizedResponse());
    }
  }, {
    key: "updateMember",
    value: function updateMember(member) {
      return _classPrivateFieldGet(this, _client).updateMember({
        token: this.getSessionToken(),
        member: member
      });
    }
  }, {
    key: "changePassword",
    value: function changePassword(member) {
      return _classPrivateFieldGet(this, _client).changePassword({
        token: this.getSessionToken(),
        member: member
      });
    }
  }, {
    key: "logOut",
    value: function logOut() {
      var token = this.getSessionToken();
      if (token) {
        _classPrivateFieldGet(this, _persistence).deleteSessionToken();
        _classPrivateFieldGet(this, _analytics).reset();
        return _classPrivateFieldGet(this, _client).deleteSession({
          token: token
        });
      }
      return _Promise.resolve(createFakeSuccessfulLogoutResponse());
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      var _this4 = this;
      return _classPrivateFieldGet(this, _client).deactivate({
        token: this.getSessionToken()
      }).then(function (result) {
        _classPrivateFieldGet(_this4, _persistence).deleteSessionToken();
        return result;
      });
    }
  }, {
    key: "sendResetPasswordEmail",
    value: function sendResetPasswordEmail(_ref) {
      var email = _ref.email;
      return _classPrivateFieldGet(this, _client).sendResetPasswordLink({
        email: email
      });
    }
  }, {
    key: "resetPassword",
    value: function resetPassword(params) {
      return _classPrivateFieldGet(this, _client).resetPasswordTokens(params);
    }
  }, {
    key: "validResetPasswordToken",
    value: function validResetPasswordToken(resetPasswordToken) {
      return _classPrivateFieldGet(this, _client).validResetPasswordToken(resetPasswordToken);
    }
  }]);
  return MembershipService;
}();
export { MembershipService as default };